import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../../../../../../service/udnick';

export const tipoVolume = {
  getVolumes: (): Promise<AxiosResponse> => UDNICK.callService('getVolumes', {}),
};
